import React from 'react';
import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { JournalPostStatus, SalaryPaymentStatus } from '../../interfaces/salaryPayment';

interface Props {
    status: SalaryPaymentStatus;
    journalPostStatus?: JournalPostStatus;
}

type ChipColor = 'success' | 'warning' | 'error' | 'default';

const paymentColor = (s: SalaryPaymentStatus): ChipColor => {
    switch (s) {
        case 'COMPLETED': return 'success';
        case 'PENDING': return 'warning';
        case 'REVERSED': return 'default';
        default: return 'default';
    }
};

const journalColor = (s: JournalPostStatus): ChipColor => {
    switch (s) {
        case 'POSTED': return 'success';
        case 'PENDING': return 'warning';
        case 'FAILED': return 'error';
        case 'SKIPPED': return 'default';
        default: return 'default';
    }
};

const PaymentStatusChip: React.FC<Props> = ({ status, journalPostStatus }) => {
    const { t } = useTranslation('payroll');
    return (
        <Box sx={{ display: 'inline-flex', gap: 0.5, flexWrap: 'wrap' }}>
            <Chip size="small" label={t(`paymentStatus.${status}`)} color={paymentColor(status)} />
            {journalPostStatus && (
                <Chip
                    size="small"
                    variant="outlined"
                    label={t('paymentStatusChip.journal', { status: t(`journalStatus.${journalPostStatus}`) })}
                    color={journalColor(journalPostStatus)}
                />
            )}
        </Box>
    );
};

export default PaymentStatusChip;
